/**
 * L'onglet est-il celui que l'utilisateur regarde ? supabase-js partage la
 * session entre les onglets : quand on se connecte dans un onglet, TOUS les
 * autres reçoivent la session. Une page qui réagit à une connexion (retour
 * mémorisé, départ vers l'onboarding) ne doit le faire que dans l'onglet
 * visible — sinon un onglet en arrière-plan (ex. une carte ouverte plus tôt)
 * écrase le retour prévu par l'onglet où l'on s'inscrit.
 */
export function isActiveTab(): boolean {
  if (typeof document === 'undefined') return true;
  return document.visibilityState !== 'hidden';
}
